export function injectShowroom({ onLoad = () => {} }: { onLoad: (result: boolean) => void }) {
  const scriptId = 'avp-3dws-deck-script';
  const existingScript = document.getElementById(scriptId);

  if (!existingScript && import.meta.env.MODE !== 'test') {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://avp-3dws-deck.eu-west-1-web-streaming.avp.tech/avp-3dws-deck.js';
    script.id = scriptId;
    script.onload = () => onLoad(true);
    document.head.appendChild(script);
  } else {
    onLoad(true);
  }
}
